export enum InstallationStatus {
  PROCESSING = 'PROCESSING',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
}

export enum MessageCode {
  ONBOARDING_COMPLETED = 'ONBOARDING_COMPLETED',
  ACTIVE_ACCOUNT = 'ACTIVE_ACCOUNT',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
  DISABLED_ACCOUNT_PAST_DUE_FIELDS = 'DISABLED_ACCOUNT_PAST_DUE_FIELDS',
  DISABLED_ACCOUNT_REJECTED = 'DISABLED_ACCOUNT_REJECTED',
  RESTRICTED_ACCOUNT = 'RESTRICTED_ACCOUNT',
  DISABLED_CARD_PAYMENTS = 'DISABLED_CARD_PAYMENTS',
  DUE_FIELDS = 'DUE_FIELDS',
  DUE_DOCUMENTS = 'DUE_DOCUMENTS',
  DUE_FIELDS_WITH_DEADLINE = 'DUE_FIELDS_WITH_DEADLINE',
  PAST_DUE_FIELDS = 'PAST_DUE_FIELDS',
}

export enum NextActionCode {
  COMPLETE_FORM = 'COMPLETE_FORM',
  UPLOAD_DOCUMENTS = 'UPLOAD_DOCUMENTS',
  COMPLETE_EXTERNAL_FORM_INDIVIDUAL = 'COMPLETE_EXTERNAL_FORM_INDIVIDUAL',
  COMPLETE_EXTERNAL_FORM_COMPANY = 'COMPLETE_EXTERNAL_FORM_COMPANY',
  CONTACT_SUPPORT = 'CONTACT_SUPPORT',
}

export enum MessageSeverity {
  INFO = 0,
  WARNING = 1,
  CRITICAL = 2,
}

export interface MessageInfo {
  code: MessageCode;
  severity: MessageSeverity;
}

export interface NextActionInfo {
  code: NextActionCode;
  deadline?: string;
}

export interface InstallationResponse {
  storeId: number;
  status: InstallationStatus;
  url?: string;
  message?: MessageInfo;
  nextAction?: NextActionInfo;
}
